import { DocumentationLegacyPageBlock, } from "../SDKDocumentationLegacyPageBlock";
// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: -  Object Definition
export class DocumentationLegacyPageBlockCustom extends DocumentationLegacyPageBlock {
    // --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
    // MARK: - Constructor
    constructor(model, children, customBlocks) {
        var _a;
        super(model, children);
        this.key = model.customBlockKey;
        // Attach custom block
        this.block = null;
        this.block =
            (_a = customBlocks.findLast((customBlock) => customBlock.key === model.customBlockKey)) !== null && _a !== void 0 ? _a : null;
        // If there is no block attached, it means the block was removed - ignore the payload resolution
        if (!this.block) {
            this.properties = {};
            return;
        }
        // With proper custom block found, add default values for properties first
        const properties = {};
        this.block.properties.forEach((property) => {
            // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
            properties[property.key] = property.default;
        });
        // Add overrides
        // @ts-expect-error TS(2532): Object is possibly 'undefined'.
        model.customBlockProperties.forEach((property) => {
            var _a, _b, _c, _d;
            // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
            properties[property.key] = property.value;
            // Deprecated. Old image asset type for backward compatibility
            const legacyValue = property.value;
            if ((legacyValue === null || legacyValue === void 0 ? void 0 : legacyValue.asset) || (legacyValue === null || legacyValue === void 0 ? void 0 : legacyValue.asset) === null) {
                legacyValue.assetId = (_b = (_a = legacyValue.asset) === null || _a === void 0 ? void 0 : _a.id) !== null && _b !== void 0 ? _b : null;
                legacyValue.assetUrl = (_d = (_c = legacyValue.asset) === null || _c === void 0 ? void 0 : _c.url) !== null && _d !== void 0 ? _d : null;
            }
        });
        this.properties = properties;
    }
}
